"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuoteEntryDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_quote_entry_entity_1 = require("./opportunity-quote-entry.entity");
const file_upload_entity_1 = require("./file-upload.entity"); // Assuming you have a documents table
let OpportunityQuoteEntryDocumentMap = class OpportunityQuoteEntryDocumentMap {
};
exports.OpportunityQuoteEntryDocumentMap = OpportunityQuoteEntryDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntryDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_quote_entry_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntryDocumentMap.prototype, "opportunityQuoteEntryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntryDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], OpportunityQuoteEntryDocumentMap.prototype, "document", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_quote_entry_entity_1.OpportunityQuoteEntry, (entry) => entry.documentMappings, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_quote_entry_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], OpportunityQuoteEntryDocumentMap.prototype, "quoteEntry", void 0);
exports.OpportunityQuoteEntryDocumentMap = OpportunityQuoteEntryDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote_entry_document_map")
], OpportunityQuoteEntryDocumentMap);
